import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5424177d&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=5424177d&prod&lang=scss"
import style1 from "./company.vue?vue&type=style&index=1&id=5424177d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424177d",
  null
  
)

export default component.exports